import { render, staticRenderFns } from "./DataHistoryItem.vue?vue&type=template&id=4b3ec7c4&scoped=true"
import script from "./DataHistoryItem.vue?vue&type=script&lang=js"
export * from "./DataHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./DataHistoryItem.vue?vue&type=style&index=0&id=4b3ec7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ec7c4",
  null
  
)

export default component.exports